import { render, staticRenderFns } from "./SellerProfile.vue?vue&type=template&id=2f27abbe&scoped=true"
import script from "./SellerProfile.vue?vue&type=script&lang=js"
export * from "./SellerProfile.vue?vue&type=script&lang=js"
import style0 from "./SellerProfile.vue?vue&type=style&index=0&id=2f27abbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f27abbe",
  null
  
)

export default component.exports